'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { ConversionTimingMetrics } from './ConversionTimingMetrics';
import { useCheckoutToOrderPaidTimeData } from '@/lib/api/analytics';
import { useStatsFilters } from '../context/StatsFiltersContext';

interface CheckoutToOrderPaidTimeProps {
    className?: string;
}

export function CheckoutToOrderPaidTime({ className = '' }: CheckoutToOrderPaidTimeProps) {
    const { t } = useTranslation('analytics');
    const { selectedDates, selectedStores, selectedCurrency } = useStatsFilters();

    const { data, isLoading, error } = useCheckoutToOrderPaidTimeData(
        {
            startDate: selectedDates.from!,
            endDate: selectedDates.to!,
            storeIds: selectedStores,
            currency: selectedCurrency,
        },
        {
            enabled: !!(selectedDates.from && selectedDates.to),
        }
    );

    return (
        <ConversionTimingMetrics
            title={t('conversion.timing.checkoutToOrderPaid.title')}
            description={t('conversion.timing.checkoutToOrderPaid.description')}
            data={data}
            isLoading={isLoading}
            error={error}
        />
    );
}
